
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ProductsCatalog Action/Mutation Types. Use it in   products/actions.js, products/mutations.js and the Vuex Host Component 

export const ProductsCatalogData = createActionTypeModel('ProductsCatalogData');
export const ProductList = createActionTypeModel('ProductList');
export const ProductDetails = createActionTypeModel('ProductDetails');
export const PriceList = createActionTypeModel('PriceList');
export const ProductGroups=createActionTypeModel('ProductGroups');

export const ProductAccounts=createActionTypeModel('ProductAccounts');
export const ProductTracks=createActionTypeModel('ProductTracks');
export const ProductMedia=createActionTypeModel('ProductMedia');
export const ProductManufacture=createActionTypeModel('ProductManufacture');
export const BackOrder=createActionTypeModel('BackOrder');
export const OpenOrder=createActionTypeModel('OpenOrder');
export const ProductManualMatches=createActionTypeModel('ProductManualMatches');
export const CountryRestricted=createActionTypeModel('CountryRestricted');
export const HarryFox=createActionTypeModel('HarryFox');
export const ProductMetaData=createActionTypeModel('ProductMetaData');
export const Royalty=createActionTypeModel('Royalty');
export const Stocks=createActionTypeModel('Stocks');
export const OnlyTracks=createActionTypeModel('OnlyTracks');
export const TrackList=createActionTypeModel('TrackList');
export const SET_CATALOG_PRODUCT_FILES = 'SET_CATALOG_PRODUCT_FILES';
export const SET_CATALOG_PRODUCT_ARTWORK = 'SET_CATALOG_PRODUCT_ARTWORK';
export const SET_COPY_TRACK='SET_COPY_TRACK';
export const SET_STOCK_RELOCATION='SET_STOCK_RELOCATION';
export const UPDATE_PLAYTIME='UPDATE_PLAYTIME';
export const UPDATE_PRODUCT_DETAILS_STATE = 'UPDATE_PRODUCT_DETAILS_STATE'